import {participantsRX, participantsScale} from "./participants";
import {Heat, Team, WodCat} from "./types";


const getTeam = (athlete: string): Team | undefined => {
    const rx = participantsRX
        .find(t => t.athlete1.toLowerCase() === athlete.toLowerCase()
            || t.athlete2.toLowerCase() === athlete.toLowerCase());
    if (!rx) {
        return participantsScale
            .find(t => t.athlete1.toLowerCase() === athlete.toLowerCase()
                || t.athlete2.toLowerCase() === athlete.toLowerCase());
    }
    return rx;
}

const getHeatTeams = (names: string []): Team [] => {
    return names.map(n => getTeam(n)).filter(t => t !== undefined) as Team [];
}

const wod1ScaleHeat1: Heat = {
    number: 1,
    category: WodCat.SCALE,
    name: "Event 2 (Scale)",
    teams: getHeatTeams(["Audrey", "Olivier", "Daniel", "Damien", "Lucile"])
}

const wod1ScaleHeat2: Heat = {
    number: 2,
    category: WodCat.SCALE,
    name: "Event 2 (Scale)",
    teams: getHeatTeams(["Antoine", "Rachel",  "Kwan", "Ornela","Bamba"])
}

const wod1ScaleHeat3: Heat = {
    number: 3,
    category: WodCat.SCALE,
    name: "Event 2 (Scale)",
    teams: getHeatTeams(["Muller", "La Noe", "Laura", "Felix", "Marie-Pier"]),
    differentCategoryIndex: [4]
}

const wod1RXHeat1: Heat = {
    number: 1,
    category: WodCat.RX,
    name: "Event 2 (RX)",
    teams: getHeatTeams(["Tanya", "Andrea", "Ashley", "Alex", "Charo"])
}

const wod1RXHeat2: Heat = {
    number: 2,
    category: WodCat.RX,
    name: "Event 2 (RX)",
    teams: getHeatTeams(["Killian", "Kass", "Katie", "Josianne", "Maude"])
}

const getHeats = () => [
    wod1ScaleHeat1,
    wod1ScaleHeat2,
    wod1ScaleHeat3,
    wod1RXHeat1,
    wod1RXHeat2
];

export {getHeats}